import React, { useEffect, useState, Children } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import Select from "react-select";
import { Button, Modal, Form, Badge, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { getApiPath, GENERIC_DATA_CREATE, GENERIC_DATA_EDIT, DYNAMIC_TABLE, DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET, DYNAMIC_TABLE_GET_ALL } from "../../../api/ApiConst";
import apiCaller from "../../../api/ApiCaller";
import {
    TABLE_ATTRIBUTE_TYPES,
    TYPES,
    TEXT_TYPES,
    NUMBER_TYPES,
    TEXTAREA_TYPES,
    RADIO_TYPES,
} from "../../../settings/constants/types";
import CollectionObjectDropdown from "./CollectionObjectDropdown";
import CollectionObjectListDropdown from "./CollectionObjectListDropdown";
import { useNavigate, useParams } from "react-router-dom";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const AddEditTableRecord = ({
    isOpen = false,
    tablePathValue = "",
    fields = [],
    rowData = null,
    successCallBack,
    onClose,
    allTableList = []
}) => {

    const [formFields, setFormFields] = useState({});
    const [referenceTable, setReferenceTable] = useState(null)
    const [showAddMoreForm, setShowAddMoreForm] = useState(false)
    const [addMoreFieldName, setAddMoreFieldName] = useState(null)
    const formFieldsKeys = Object.keys(formFields);
    const allTypes = Object.assign(
        {},
        ...fields.map((field) => ({ [field.name]: field?.type }))
    );
    const actionType = rowData ? "Update" : "Create";

    const handleChange = (event) => {
        if (event?.target?.type === TYPES.BOOLEAN) {
            setFormFields((prev) => ({
                ...prev,
                [event.target.name]: event.target.value === "true",
            }));
            return;
        }

        setFormFields((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    };

    const handleChangeCollectionObjectList = (event) => {
        let payload = event?.target?.value?.map((item) => ({id: item.value, name: item.label}));
        setFormFields((prev) => ({
            ...prev,
            [event.target.name]: payload,
        }));
    };

    const handleSuccess = () => {
        onClose();
        successCallBack();
    };
    const handleError = (error) => toast.error(error.response.data.message);

    const handleCreateUpdateTableData = () => {
        if (rowData) {
            const editURL = `${getApiPath(tablePathValue, GENERIC_DATA_EDIT)}/${rowData.id}`;

            apiCaller.callPutApi(editURL, formFields, {}, handleSuccess, handleError);
            return;
        }

        apiCaller.callPostApi(
            getApiPath(tablePathValue, GENERIC_DATA_CREATE),
            formFields,
            {},
            handleSuccess,
            handleError
        );
    };

    useEffect(() => {
        if (isOpen) {
            setFormFields(
                Object.assign(
                    {},
                    ...fields.map((field) => ({
                        [field.name]: rowData ? get(rowData, field.name) : "",
                    }))
                )
            );
        }
    }, [isOpen]);

    const handleAddNewCollectionObjectList = (key) => {
        let referenceTable = fields.find((field) => field.name === key)
        setReferenceTable(referenceTable)
        setShowAddMoreForm(true)
        setAddMoreFieldName(key)
    }

    return (
        <>
        {
            <Modal show={isOpen} onHide={onClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{`${actionType} ${tablePathValue} record`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="mb-3">    
                        <Row>
                            {formFieldsKeys &&
                                Children.toArray(
                                    formFieldsKeys.map((key, index) => {
                                        const type = allTypes[key];
                                        const isTextOrNumberType =
                                            TEXT_TYPES.includes(type) || NUMBER_TYPES.includes(type);

                                        const enumOptions =
                                            type === TABLE_ATTRIBUTE_TYPES.ENUM &&
                                            get(
                                                fields.find((field) => field.name === key),
                                                "enumValues"
                                            );

                                return (
                                    <Col lg={6} xl={4} key={index}>
                                        {isTextOrNumberType && (
                                            type === "DATE" ?

                                            <Form.Group className="mt-3 datepicker-container">
                                                <Form.Label>
                                                    {key} <Badge bg="info">{type}</Badge>
                                                </Form.Label>
                                                <DateTime
                                                    className="form-control"
                                                    name={key}
                                                    value={formFields[key]}
                                                    onChange={(date) => handleChange({
                                                        target: { name: key, value: date }
                                                    })}
                                                    dateFormat="YYYY-MM-DD"
                                                    timeFormat={false}
                                                />
                                            </Form.Group>

                                            :

                                            <Form.Group className="mt-3">
                                                <Form.Label>
                                                    {key} <Badge bg="info">{type}</Badge>
                                                </Form.Label>
                                                <input
                                                    className="form-control"
                                                    type={TYPES[type]}
                                                    placeholder={key}
                                                    name={key}
                                                    value={formFields[key]}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        )}
                                       
                                        {TEXTAREA_TYPES.includes(type) && (
                                            <Form.Group className="mt-3">
                                                <Form.Label>
                                                    {key} <Badge bg="info">{type}</Badge>
                                                </Form.Label>
                                                <textarea
                                                    className="form-control"
                                                    name={key}
                                                    cols={50}
                                                    rows={4}
                                                    placeholder={key}
                                                    value={formFields[key]}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </Form.Group>
                                        )}

                                                {type === TABLE_ATTRIBUTE_TYPES.ENUM && (
                                                    <Form.Group className="mt-3">
                                                        <Form.Label>
                                                            {key} <Badge bg="info">{type}</Badge>
                                                        </Form.Label>
                                                        <Select
                                                            name={key}
                                                            value={{
                                                                label: formFields[key],
                                                                value: formFields[key],
                                                            }}
                                                            options={
                                                                enumOptions
                                                                    ? enumOptions
                                                                        .split(",")
                                                                        .filter(Boolean)
                                                                        .map((option) => ({
                                                                            label: option,
                                                                            value: option,
                                                                        }))
                                                                    : []
                                                            }
                                                            onChange={(event) =>
                                                                handleChange({
                                                                    target: { name: key, value: event.value },
                                                                })
                                                            }
                                                            className="react-select-container"
                                                        />
                                                    </Form.Group>
                                                )}
                                               
                                                {type === TABLE_ATTRIBUTE_TYPES.COLLECTION_OBJECT && (
                                                    <Form.Group className="mt-3">
                                                        <Form.Label>
                                                            {key} <Badge bg="info">{type}</Badge>
                                                        </Form.Label>
                                                        <CollectionObjectDropdown
                                                            field={fields.find((field) => field.name === key)}
                                                            name={key}
                                                            value={formFields[key]}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                )}


                                                {
                                                    type === TABLE_ATTRIBUTE_TYPES.COLLECTION_OBJECT_LIST && (
                                                    <Form.Group className="mt-3">
                                                        <Form.Label className="d-flex justify-content-between gap-1 align-items-center">
                                                            <div>{key} <Badge bg="info">{type}</Badge></div>
                                                            <Badge 
                                                                type="div"
                                                                size="sm" 
                                                                variant="primary" 
                                                                onClick={(e)=>{
                                                                    e.preventDefault();
                                                                    handleAddNewCollectionObjectList(key)
                                                                }}
                                                                style={{
                                                                    fontSize: "12px",
                                                                    width: "100px",
                                                                    display:"block",
                                                                    cursor: "pointer",
                                                                    padding: "8px 10px",
                                                                    borderRadius: "5px",
                                                                    backgroundColor: "#007bff",
                                                                    color: "#fff",
                                                                    textAlign: "center",
                                                                    marginTop: "5px"
                                                                }}
                                                            >
                                                                + Add New
                                                            </Badge>
                                                        </Form.Label>
                                                        <CollectionObjectListDropdown
                                                            field={fields.find((field) => field.name === key)}
                                                            name={key}
                                                            value={formFields[key]}
                                                            onChange={handleChangeCollectionObjectList}
                                                        />
                                                    </Form.Group>
                                                )}

                                                {RADIO_TYPES.includes(type) && (
                                                    <Form.Group className="mt-3">
                                                        <Form.Label>
                                                            {key} <Badge bg="info">{type}</Badge>
                                                        </Form.Label>
                                                        <br />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            id={`${key}-${type}-1`}
                                                            name={key}
                                                            label="Yes"
                                                            value={true}
                                                            checked={formFields[key] === true}
                                                            onChange={handleChange}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            id={`${key}-${type}-2`}
                                                            name={key}
                                                            label="No"
                                                            value={false}
                                                            checked={formFields[key] === false}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                )}
                                            </Col>
                                        );
                                    })
                                )}
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={!tablePathValue || isEmpty(formFields)}
                        variant="primary"
                        onClick={handleCreateUpdateTableData}
                    >
                        {actionType}
                    </Button>
                </Modal.Footer>
            </Modal>
        }
            {
                showAddMoreForm && (
                    <AddMoreForm 
                       show={showAddMoreForm} 
                        setShow={setShowAddMoreForm} 
                        referenceTable={referenceTable} 
                        allTableList={allTableList} 
                        addMoreFieldName={addMoreFieldName}
                        setFormFields={setFormFields}
                        formFields={formFields}
                    />
                )
            }
        </>
    );
};

export default AddEditTableRecord;


const AddMoreForm = ({show, setShow, referenceTable, allTableList, addMoreFieldName, setFormFields,formFields}) => {
    const [addMoreFormFields, setAddMoreFormFields] = useState({})
    const [dynamicFormFields, setDynamicFormFields] = useState([])

    useEffect(()=>{
        getTableAttributeListForTableColumns()
    }, [])

    const getTableAttributeListForTableColumns =() => {
        var jsonRequest = {
            "page": 0,
            "size": 100,
            searchFilters: [],
            sortRules: [],
        };
        let attributesUrl = DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll("{dynamic-table-id}", (referenceTable?.referenceTable))
        const formOptions = [];
        apiCaller.callPostApi(attributesUrl, jsonRequest, {}, (response) => {
            response.data.map((d, i) => {
                if (d.formAttribute) {
                    let tablePathIs = allTableList.find(obj => obj.id === d.referenceTable);
                    formOptions.push({
                        name: d.name,
                        formAttribute: d.formAttribute,
                        type: d.type,
                        referenceTable: d.referenceTable,
                        keyValuePair: { keyAttribute: d.keyAttribute, valueAttribute: d.valueAttribute },
                        referenceTablePath: (tablePathIs) ? tablePathIs?.pathValue : null,
                        enumValues: d.enumValues
                    });
                    
                }
            })
            setDynamicFormFields(formOptions)
            setAddMoreFormFields(
                Object.assign(
                    {},
                    ...formOptions.map((field) => ({
                        [field.name]: formFields?.[addMoreFieldName]?.[field.name]===0?0:
                        formFields?.[addMoreFieldName]?.[field.name]===false?false:
                        formFields?.[addMoreFieldName]?.[field.name]||"",
                    }))
                )
            );
        }, (error) => {
            console.error(error);
        })
    }

    const handleChange = (event) => {
        if (event?.target?.type === TYPES.BOOLEAN) {
            setAddMoreFormFields((prev) => ({
                ...prev,
                [event.target.name]: event.target.value === "true",
            }));
            return;
        }

        setAddMoreFormFields((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    };

    const handleChangeCollectionObjectList = (event) => {
        let payload = event?.target?.value?.map((item) => ({id: item.value, name: item.label}));
        setAddMoreFormFields((prev) => ({
            ...prev,
            [event.target.name]: payload,
        }));
    };

    const formFieldsKeys = Object.keys(addMoreFormFields);
    const allTypes = Object.assign(
        {},
        ...dynamicFormFields.map((field) => ({ [field.name]: field?.type }))
    );
    
    const handleAddMoreForm = () => {
        if(!checkFormFields()){
            return;
        }
        setFormFields((prev) => ({
            ...prev,
            [addMoreFieldName]: [...(formFields?.[addMoreFieldName]||[]), {...(addMoreFormFields||{})}],
        }));
        setShow(false)
    }
    const checkFormFields = () => {
        let isFormValid = true;
        for(let key in addMoreFormFields){
            if((typeof addMoreFormFields[key] === "string" && addMoreFormFields[key]?.trim() === "") || addMoreFormFields[key] === null || addMoreFormFields[key] === undefined){
                isFormValid = false;
                toast.error(`${key} is required`)
                break;
            }
        }
        return isFormValid;
    }


    return (
        <Modal show={show} onHide={()=>setShow(false)} className="add-more-form" size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Add {referenceTable?.referenceTablePath}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="mb-3">
                    <Row>
                        {formFieldsKeys &&
                            Children.toArray(
                                formFieldsKeys.map((key, index) => {
                                    const type = allTypes[key];
                                    const isTextOrNumberType =
                                        TEXT_TYPES.includes(type) || NUMBER_TYPES.includes(type);

                                    const enumOptions =
                                        type === TABLE_ATTRIBUTE_TYPES.ENUM &&
                                        get(
                                            dynamicFormFields.find((field) => field.name === key),
                                            "enumValues"
                                        );

                                    return (
                                        <Col lg={6} xl={4} key={index}>
                                            {isTextOrNumberType && (
                                                <Form.Group className="mt-3">
                                                    <Form.Label>
                                                        {key} <Badge bg="info">{type}</Badge>
                                                    </Form.Label>
                                                    <input
                                                        className="form-control"
                                                        type={TYPES[type]}
                                                        placeholder={key}
                                                        name={key}
                                                        value={addMoreFormFields[key]}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            )}

                                            {TEXTAREA_TYPES.includes(type) && (
                                                <Form.Group className="mt-3">
                                                    <Form.Label>
                                                        {key} <Badge bg="info">{type}</Badge>
                                                    </Form.Label>
                                                    <textarea
                                                        className="form-control"
                                                        name={key}
                                                        cols={50}
                                                        rows={4}
                                                        placeholder={key}
                                                        value={addMoreFormFields[key]}
                                                        onChange={handleChange}
                                                    ></textarea>
                                                </Form.Group>
                                            )}

                                            {type === TABLE_ATTRIBUTE_TYPES.ENUM && (
                                                <Form.Group className="mt-3">
                                                    <Form.Label>
                                                        {key} <Badge bg="info">{type}</Badge>
                                                    </Form.Label>
                                                    <Select
                                                        name={key}
                                                        value={{
                                                            label: addMoreFormFields[key],
                                                            value: addMoreFormFields[key],
                                                        }}
                                                        options={
                                                            enumOptions
                                                                ? enumOptions
                                                                    .split(",")
                                                                    .filter(Boolean)
                                                                    .map((option) => ({
                                                                        label: option,
                                                                        value: option,
                                                                    }))
                                                                : []
                                                        }
                                                        onChange={(event) =>
                                                            handleChange({
                                                                target: { name: key, value: event.value },
                                                            })
                                                        }
                                                        className="react-select-container"
                                                    />
                                                </Form.Group>
                                            )}

                                            {type === TABLE_ATTRIBUTE_TYPES.COLLECTION_OBJECT && (
                                                <Form.Group className="mt-3">
                                                    <Form.Label>
                                                        {key} <Badge bg="info">{type}</Badge>
                                                    </Form.Label>
                                                    <CollectionObjectDropdown
                                                        field={dynamicFormFields.find((field) => field.name === key)}
                                                        name={key}
                                                        value={addMoreFormFields[key]}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            )}

                                            {type === TABLE_ATTRIBUTE_TYPES.COLLECTION_OBJECT_LIST && (
                                                <Form.Group className="mt-3">
                                                    <Form.Label>
                                                        {key} <Badge bg="info">{type}</Badge>
                                                    </Form.Label>
                                                    <CollectionObjectListDropdown
                                                        field={dynamicFormFields.find((field) => field.name === key)}
                                                        name={key}
                                                        value={addMoreFormFields[key]}
                                                        onChange={handleChangeCollectionObjectList}
                                                    />
                                                </Form.Group>
                                            )}

                                            {RADIO_TYPES.includes(type) && (
                                                <Form.Group className="mt-3">
                                                    <Form.Label>
                                                        {key} <Badge bg="info">{type}</Badge>
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        id={`${key}-${type}-1`}
                                                        name={key}
                                                        label="Yes"
                                                        value={true}
                                                        checked={addMoreFormFields[key] === true}
                                                        onChange={handleChange}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        id={`${key}-${type}-2`}
                                                        name={key}
                                                        label="No"
                                                        value={false}
                                                        checked={addMoreFormFields[key] === false}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            )}
                                        </Col>
                                    );
                                })
                            )}
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => {
                    handleAddMoreForm()
                }}>
                    Add
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
